module.exports = __webpack_public_path__ + "static/media/composição.808cadd1.svg";